import {
  Avatar,
  AvatarFallback,
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui";
import { MenuIcon } from "lucide-react";
import useHeader from "./useHeader";
import { Sidebar } from "../Sidebar";
import { Dialog } from "@/components";
import logo from "@/assets/ostwal-logo.png";

const Header = () => {
  const {
    isOpen,
    onLogoutClick,
    handleClose,
    setIsOpen,
    isLogoutOpen,
    setIsLogoutOpen,
    onLogout,
    isProfileMenuOpen,
    setIsProfileMenuOpen,
    loggedInUserData,
  } = useHeader();

  return (
    <>
      <header className="bg-header-bg fixed w-full flex items-center px-4 z-50 text-white">
        {/* This only for mobile menu */}
        <div className="flex flex-row items-center justify-between">
          <Popover open={isOpen} onOpenChange={setIsOpen}>
            <PopoverTrigger className="lg:hidden" asChild>
              <Button variant="ghost">
                <MenuIcon />
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-full ml-[20px] bg-white p-3 shadow-lg rounded-sm">
              <Sidebar handleClose={handleClose} />
            </PopoverContent>
          </Popover>
          <div className="flex flex-row items-center justify-between">
            <img src={logo} className="w-[50px] md:w-[50px]" />
          </div>
        </div>
        <div className="flex justify-end w-full items-center relative">
          {/* For Profile Menu */}

          <Popover open={isProfileMenuOpen} onOpenChange={setIsProfileMenuOpen}>
            <PopoverTrigger asChild>
              <div className="cursor-pointer flex flex-row items-center justify-between border-l-1 border-g-200 py-2 px-3 ml-3 w-[120px] md:w-[130px]">
                <Avatar className="h-[40px] w-[40px]">
                  {/* <AvatarImage
                    src="https://github.com/shadcn.png"
                    alt="@shadcn"
                  /> */}
                  <AvatarFallback className="bg-primary text-white">{`${loggedInUserData?.fullName
                    ?.split(" ")?.[0]
                    ?.charAt(0)
                    ?.toUpperCase()}${loggedInUserData?.fullName
                    ?.split(" ")?.[1]
                    ?.charAt(0)
                    ?.toUpperCase()}`}</AvatarFallback>
                </Avatar>
                <div className="flex flex-col">
                  <span className="text-[12px]">
                    {loggedInUserData?.fullName?.split(" ")?.[0] || ""}
                  </span>
                  <span className="text-[12px] opacity-[68%]">{"Admin"}</span>
                </div>
              </div>
            </PopoverTrigger>
            <PopoverContent className="min-w-[135px] w-full bg-white p-3 shadow-lg rounded-sm">
              <div className="text-[12px] text-primary">
                <Button
                  type="button"
                  variant="ghost"
                  className="w-full shadow-none p-0 h-[20px] rounded-sm hover:bg-blue-50 hover:text-primary ring-none focus-visible:border-none focus-visible:ring-0 py-4"
                  onClick={onLogoutClick}
                >
                  Logout
                </Button>
              </div>
            </PopoverContent>
          </Popover>
        </div>
      </header>
      {isLogoutOpen && (
        <Dialog
          open={isLogoutOpen}
          setOpen={setIsLogoutOpen}
          title={<h2 className="text-2xl font-bold">Logout</h2>}
          onSave={onLogout}
          saveText="Logout"
        >
          <div className="flex flex-col gap-4">
            <p>Are you sure you want to logout?</p>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default Header;
